/* global $ */

/*Boxes AutoHeight*/
function setEqualHeight(columns) {
    var tallestcolumn = 0;
    columns.each(function() {
        $(this).css('height', 'auto');
        var currentHeight = $(this).height();
        if (currentHeight > tallestcolumn) {
            tallestcolumn = currentHeight;
        }
    });
    columns.height(tallestcolumn);
}

export default setEqualHeight;



// WEBPACK FOOTER //
// ./src/modules/plugins/setEqualHeight.js